import {gql} from '@apollo/client'

// NOTE: These mutations do not exist yet on the backend. They are written to
// match the naming/shape conventions of `settingsMutations.ts`
// (createSetting/updateSetting/deleteSetting) against the
// OnboardingStepMessage / RequiredDocumentConfig / OrganizationOnboardingConfig
// models in `onboarding/models.py`. A backend follow-up is required to add an
// admin-facing (staff-authenticated) GraphQL app exposing these — see the
// frontend task report for exact expected input/payload shapes.

export const CREATE_ONBOARDING_STEP_MESSAGE = gql`
  mutation createOnboardingStepMessage($stepMessageData: onboarding_step_message_input!) {
    createOnboardingStepMessage(stepMessageData: $stepMessageData) {
      stepMessage {
        id
        stepKey
        message
        isActive
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_ONBOARDING_STEP_MESSAGE = gql`
  mutation updateOnboardingStepMessage($id: ID!, $stepMessageData: onboarding_step_message_input!) {
    updateOnboardingStepMessage(id: $id, stepMessageData: $stepMessageData) {
      stepMessage {
        id
        stepKey
        message
        isActive
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_ONBOARDING_STEP_MESSAGE = gql`
  mutation deleteOnboardingStepMessage($id: ID!) {
    deleteOnboardingStepMessage(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_REQUIRED_DOCUMENT_CONFIG = gql`
  mutation createRequiredDocumentConfig($requiredDocumentData: required_document_config_input!) {
    createRequiredDocumentConfig(requiredDocumentData: $requiredDocumentData) {
      requiredDocument {
        id
        documentType
        context
        isRequired
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_REQUIRED_DOCUMENT_CONFIG = gql`
  mutation updateRequiredDocumentConfig($id: ID!, $requiredDocumentData: required_document_config_input!) {
    updateRequiredDocumentConfig(id: $id, requiredDocumentData: $requiredDocumentData) {
      requiredDocument {
        id
        documentType
        context
        isRequired
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_REQUIRED_DOCUMENT_CONFIG = gql`
  mutation deleteRequiredDocumentConfig($id: ID!) {
    deleteRequiredDocumentConfig(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

// Updates the signature_forms M2M on OrganizationOnboardingConfig. Creates
// the config row (organization OneToOne) if it doesn't exist yet.
export const UPDATE_ORGANIZATION_ONBOARDING_SIGNATURE_FORMS = gql`
  mutation updateOrganizationOnboardingSignatureForms($organization: ID!, $signatureFormIds: [ID!]!) {
    updateOrganizationOnboardingSignatureForms(
      organization: $organization
      signatureFormIds: $signatureFormIds
    ) {
      onboardingConfig {
        id
        isActive
        signatureForms {
          id
          name
        }
      }
      success
      errors {
        field
        message
      }
    }
  }
`
